
<script>
import PieChart from "../reporting/pieChart.vue";


export default {

  components: { PieChart},

  props: {

    genderRate: {
        type: Object,
        default: () => null
        }
    },

 
};
</script>

<template>

    <div class="h-100" v-if="genderRate && genderRate.count && genderRate.labels ">
        <PieChart :data="genderRate.count" :labels="genderRate.labels"  />
    </div>

</template>
